<div class="formFieldsContainer" [ngClass]="{'formControlHidden': visible == false }" *ngIf="show.element">
  <span class="label" *ngIf="showLabel && label && type!='checkbox' && type!='radio' && type!='switch'">{{label}}<span class="asterix" *ngIf="required && showRequiredAsterix">&nbsp;*</span></span>
  <div class="typeInteger" *ngIf="type == 'number'" [ngClass]="{'marginTop15': !showLabel || (label != '' && label != null) }">
    <input type="number" 
    max={{maxValue}}
     min={{minValue}} 
     [ngClass]="{'errorField': valid == false}"
      disabled="{{disabled}}"
       required="{{required}}" 
       [(ngModel)]="fieldModel" 
       (ngModelChange)="modelChanged($event)" 
      placeholder="{{placeholder}}"
       step="{{step ? step : 1}}" pInputText />
  </div>

  <div class="typeRadio" *ngIf="type=='radio' && radioOptions && radioOptions.length>0 && language">
    <div class="label" *ngIf="label && showLabel==true">{{label}}<span class="asterix" *ngIf="required">*</span></div>
    <div *ngFor="let opt of radioOptions">
      <br />
      <p-radioButton name="{{opt.name}}" value="{{opt.value}}" [disabled]="disabled" [(ngModel)]="fieldModel" (ngModelChange)="modelChanged($event)" label="{{opt.label[language]}}"></p-radioButton>
    </div>
  </div> 

  <div class="typeSwitch" *ngIf="type=='switch'">
    <span class="switchTitle input-switch-container">
      <p-inputSwitch (ngModelChange)="modelChanged($event)" [(ngModel)]="fieldModel" [disabled]="disabled">
      </p-inputSwitch><span>&nbsp;&nbsp;{{label}}</span>
    </span>
  </div>


  <div class="typeString" *ngIf="type == 'string'" [ngClass]="{ 'marginTop15': !showLabel || (label != '' && label != null) }">
    <input type="text" 
    [ngClass]="{'errorField': valid == false}"
     disabled="{{disabled}}" 
     required="{{required}}"
      [(ngModel)]="fieldModel" 
      minlength="{{minLength}}"
       maxlength="{{maxLength}}"
       (ngModelChange)="modelChanged($event)"
      placeholder="{{placeholder}}"
       pInputText />
  </div>
  <div class="typeTextarea" *ngIf="type == 'textarea'" [ngClass]="{'marginTop15': !showLabel || (label != '' && label != null) }">
    <textarea [ngClass]="{'errorField': valid == false }" disabled="{{disabled}}"
      required="{{required}}" [(ngModel)]="fieldModel" minlength="{{minLength}}" maxlength="{{maxLength}}"
      [value]="fieldModel" (ngModelChange)="modelChanged($event)"></textarea>
  </div>
  <div *ngIf="type == 'combo' || type == 'dropdown'" [ngClass]="{'marginTop15':!showLabel || (label != '' && label != null) }">
    <p-dropdown 
      [filter]="filterable" 
      *ngIf="optionLabel" 
      [editable]="(serverOptions && serverOptions.service) ? true : false"
      [ngClass]="{'errorField': valid == false }"
      [style]="{'width':'100%','height':'30px'}"
       [disabled]="disabled" 
       [required]="required"
      [(ngModel)]="fieldModel"
       [options]="options"
       (onChange)="onInputChange($event)"
        name="{{name}}" 
        optionLabel="{{optionLabel}}"
      placeholder="{{placeholder}}"
       (ngModelChange)="modelChanged($event)"
       dataKey="{{dataKey}}"
      >
    </p-dropdown>
    <p-dropdown *ngIf="!optionLabel" 
    [filter]="filterable" 
    [ngClass]="{'errorField': valid == false }" 
    [editable]="(serverOptions && serverOptions.service) ? true : false"
    [style]="{'width':'100%','height':'30px'}" 
    [disabled]="disabled" 
    [required]="required" 
    [(ngModel)]="fieldModel" 
    [options]="options" 
    name="{{name}}" 
    placeholder="{{placeholder}}"
    (ngModelChange)="modelChanged($event)"></p-dropdown>
  </div>
  <div *ngIf="type == 'date'" [ngClass]="{'marginTop15': !showLabel || (label != '' && label != null) }">
    <p-calendar *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat" 
      [ngClass]="{'errorField': valid == false}" [showIcon]="true" [minDate]="minDate" [maxDate]="maxDate"
      [disabled]="disabled" [required]="required" [(ngModel)]="fieldModel" [required]="required" 
      dateFormat="{{srvCalendar.pcalendarTranslate.dateFormat}}" (ngModelChange)="modelChanged($event)"
      [locale]="srvCalendar.pcalendarTranslate"
      placeholder="{{placeholder}}"></p-calendar>
  </div>
  <div *ngIf="type == 'checkbox'" [ngClass]="{'marginTop15': !showLabel || (label != '' && label != null) }">
    <p-checkbox binary="true" [(ngModel)]="fieldModel" [value]="fieldModel" [disabled]="disabled" [required]="required" label="{{label}}" (ngModelChange)="onCheckboxChange($event)"></p-checkbox>
  </div>
  <div class="typeTime" *ngIf="type == 'time'" 
     [ngClass]="{'marginTop15': !showLabel || (label != '' && label != null)}">

  <input type="time"
         [ngClass]="{'errorField': valid == false}"
         [disabled]="disabled"
         [required]="required"
         [(ngModel)]="fieldModel"
         (ngModelChange)="modelChanged($event)"
         placeholder="{{placeholder}}"
         pInputText />
</div>


  <div *ngIf="!valid && errorMessage && errorMessage.length>0" class="errorMessage">{{errorMessage}}</div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/form-fields/form-fields.component.html